




















































































































import { Component, Vue } from 'vue-property-decorator'
import { Pipeline } from '@/api/model/pipeline'
import { availableRoles } from '@/api/types'
import { CompanyAPI, PipelineAPI } from '@/api/backend-client'
import { ListItemActionClickEvent } from '@/components/ui/list/list-item/ListItemAction.vue'
import { Company } from '@/api/model/company'
import { cloneDeep } from 'lodash'
import LoaderBalls from '@/components/LoaderBalls.vue'
import EditPipelineTurnoverModal from '@/views/Company/Settings/VirtualColleague/Turnover/EditPipelineTurnoverModal.vue'
import Tooltip from '@/components/ui/Tooltip.vue'

@Component({
    components: { Tooltip, LoaderBalls, EditPipelineTurnoverModal },
})
export default class Turnover extends Vue {
    selectedPipeline: Pipeline = null
    loadingPipelines: boolean = false
    pipelines: Pipeline[] = []
    showPipelineModal: boolean = false
    company: Company = null
    loading: boolean = false

    async created(): Promise<void> {
        await this.reload()
    }

    async mounted(): Promise<void> {
        await this.reload()
    }

    async reload(): Promise<void> {
        this.company = cloneDeep<Company>(this.$currentCompany)
        await this.loadPipelines()
        this.showPipelineModal = false
        this.selectedPipeline = null
    }

    async save(): Promise<void> {
        try {
            this.loading = true
            this.$root.$currentCompany = await CompanyAPI.update(this.company.id, this.company)
            await this.reload()

        } finally {
            this.loading = false
        }
    }

    async loadPipelines() {
        this.loadingPipelines = true
        this.pipelines = await PipelineAPI.getAll({
            company: this.$currentCompany.resourceIdentifier,
        })
        this.pipelines.sort((a, b) => a.name.localeCompare(b.name))
        this.loadingPipelines = false
    }

    async listItemClicked(event: ListItemActionClickEvent<Pipeline>) {
        if (event.item.id !== this.selectedPipeline?.id) {
            this.selectedPipeline = event.item
        } else {
            this.selectedPipeline = null
        }

        this.showPipelineModal = true
    }

    get roleOptions() {
        return availableRoles().map(value => ({
            label: this.$t(`role.${value}`),
            value,
        }))
    }

    fetchPipeline(itemId: string): Pipeline {
        return this.pipelines.find(pipeline => pipeline.id === itemId)
    }
}
